// Enable menu toggle
document.querySelector( '#mobile-menu-toggle').addEventListener( 'click', function( event ) {

  // Get the menu toggle
  const mobileMenuToggle = document.querySelector( '#mobile-menu-toggle');

  // Get the mobile menu
  const mobileMenuWrapper = document.querySelector( '#mobile-menu-wrapper');

  // If the menu isn't open yet
  if ( mobileMenuToggle.getAttribute( 'aria-expanded' ) === 'false' ) {

    // Activate the mobile menu
    mobileMenuWrapper.style.display = 'block';

    // Set the aria-expanded attribute to true
    mobileMenuToggle.setAttribute( 'aria-expanded', 'true' );

    // Update the aria label
    mobileMenuToggle.setAttribute( 'aria-label', mobileMenuToggle.getAttribute( 'aria-label' ).replace( 'Activate', 'Deactivate' ) );

    // If it wasn't a keyboard event that triggered this
    if ( event.clientX !== 0 ) {

      // Blur the menu item to remove focus styles
      mobileMenuToggle.blur();

    }

  // Otherwise the menu is already open
  } else {

    // Deactivate the mobile menu
    mobileMenuWrapper.style.display = 'none';

    // Set the aria-expanded attribute to true
    mobileMenuToggle.setAttribute( 'aria-expanded', 'false' );

    // Update the aria label
    mobileMenuToggle.setAttribute( 'aria-label', mobileMenuToggle.getAttribute( 'aria-label' ).replace( 'Deactivate', 'Activate' ) );

    // If it wasn't a keyboard event that triggered this
    if ( event.clientX !== 0 ) {

      // Blur the menu item to remove focus styles
      mobileMenuToggle.blur();

    }

  }

} );


// Loop through all mobile menu links with children
document.querySelectorAll( '.mobile-menu-link.has-children' ).forEach( function( mobileMenuItemLink ) {

  // Event listener - when this menu item link is clicked
  mobileMenuItemLink.addEventListener( 'click', function ( event ) {

    // Stop the link being followed and any propagation
    event.preventDefault();

    // Store the clicked element as a variable
    let clickedMobileMenuItemLink = event.target;

    // If the submenu isn't open yet
    if ( clickedMobileMenuItemLink.getAttribute( 'aria-expanded' ) === 'false' ) {

      // Set the aria-expanded attribute to true
      // The menu visibility is controlled by this attribute in CSS
      clickedMobileMenuItemLink.setAttribute( 'aria-expanded', 'true' );

      // Update the aria label
      clickedMobileMenuItemLink.setAttribute( 'aria-label', clickedMobileMenuItemLink.getAttribute( 'aria-label' ).replace( 'Activate', 'Deactivate' ) );

      // If it wasn't a keyboard event that triggered this
      if ( event.clientX !== 0 ) {

        // Blur the menu item to remove focus styles
        clickedMobileMenuItemLink.blur();

      }

    // Otherwise the submenu is already open
    } else {

      // Set the aria-expanded attribute to true
      // The menu visibility is controlled by this attribute in CSS
      clickedMobileMenuItemLink.setAttribute( 'aria-expanded', 'false' );

      // Update the aria label
      clickedMobileMenuItemLink.setAttribute( 'aria-label', clickedMobileMenuItemLink.getAttribute( 'aria-label' ).replace( 'Deactivate', 'Activate' ) );

      // If it wasn't a keyboard event that triggered this
      if ( event.clientX !== 0 ) {

        // Blur the menu item to remove focus styles
        clickedMobileMenuItemLink.blur();

      }

    }

  } );

} );
